// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh5[data-v-01f0d5c4] {\n  color: var(--sea);\n  font-size: var(--01f0d5c4-fontSize);\n  font-weight: 400 !important;\n}\n.trending-icon[data-v-01f0d5c4] {\n  width: var(--01f0d5c4-trendingIconSize);\n}\n.custom-icon[data-v-01f0d5c4] {\n  width: var(--01f0d5c4-customIconSize);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
